import type { FC, ReactNode } from "react";

import type { DashboardOrganizationApiKey } from "../../dashboard-client";

import { PROVIDER_LABELS } from "../../constants/providers";
import { Badge } from "./Badge";
import { Text } from "./Text";

interface ProviderKeyRowProps {
  provider: string;
  /** Override display label (e.g. for bedrock model-specific entries) */
  label?: string;
  config: DashboardOrganizationApiKey | undefined;
  extraActions?: ReactNode;
  extraPanels?: ReactNode;
}

export const ProviderKeyRow: FC<ProviderKeyRowProps> = ({
  provider,
  label,
  config,
  extraActions,
  extraPanels,
}) => {
  const isConfigured = config?.has_key === true;

  return (
    <div className="border-b border-gray-100 py-3 last:border-b-0 dark:border-white/5">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-3">
            <span className="font-mono text-[11px] font-bold text-slate-900 dark:text-white">
              {label ?? (PROVIDER_LABELS[provider] || provider)}
            </span>
            <Badge variant={isConfigured ? "success" : "default"} size="sm">
              {isConfigured ? "Configured" : "Not configured"}
            </Badge>
          </div>
          {config && (
            <Text as="div" className="mt-1 flex gap-4">
              {config.label && <span>Label: {config.label}</span>}
              <span>
                Updated: {new Date(config.updated_at).toLocaleDateString()}
              </span>
            </Text>
          )}
        </div>

        {extraActions && (
          <div className="flex items-center gap-2">{extraActions}</div>
        )}
      </div>

      {extraPanels}
    </div>
  );
};
